// @ts-nocheck

/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
var site = window.site || {};

(function () {
  window.LiveChat.lpBeautyChatOrcData = {
    divId: 'livechat_lp_drawer_beauty',
    engId: '',
    isLoopActive: false,
    isUserAwaitingChat: false,
    intentLoopTimeoutDefault: 15,
    intentLoopTimeoutCounter: 15,
    intentLoopFinishedEventName: 'livechat_lp_drawer_beauty_intent_loop_complete',
    errorMessageEventName: 'beauty_chat_drawer_error'
  };
  window.LiveChat.lpSupportChatOrcData = {
    divId: 'livechat_lp_drawer_customer_support',
    engId: '',
    isLoopActive: false,
    isUserAwaitingChat: false,
    intentLoopTimeoutDefault: 15,
    intentLoopTimeoutCounter: 15,
    intentLoopFinishedEventName: 'livechat_lp_drawer_customer_support_intent_loop_complete',
    errorMessageEventName: 'support_chat_drawer_error'
  };
  window.LiveChat.lpChatOrcData = {
    divId: '',
    engId: '',
    isLoopActive: false,
    isUserAwaitingChat: false,
    intentLoopTimeoutDefault: 15,
    intentLoopTimeoutCounter: 15,
    intentLoopFinishedEventName: 'global_chat_intent_loop_complete',
    errorMessageEventName: 'chat_button_error'
  };

  function initEngagement(divId, engId) {
    switch (divId) {
      case window.LiveChat.lpBeautyChatOrcData.divId:
        window.LiveChat.lpBeautyChatOrcData.engId = engId;

        return true;
      case window.LiveChat.lpSupportChatOrcData.divId:
        window.LiveChat.lpSupportChatOrcData.engId = engId;

        return true;
      case window.LiveChat.lpChatOrcData.divId:
        window.LiveChat.lpChatOrcData.engId = engId;

        return true;
      default:
        throw new Error(
          `lpOrchestrator.initEngagement(): The div id used in this script is not recognized: ${divId}. The chat module for this site is misconfigured.`
        );
    }
  }

  function verifyEngagementIsReady(divId) {
    var engId = '';
    var success = false;
    var lpEngagementDiv = document.getElementById(divId);

    if (!lpEngagementDiv) return false;

    if (
      lpEngagementDiv.children.length === 0 ||
      lpEngagementDiv.children[0].children.length === 0
    ) {
      return false;
    }

    engId = lpEngagementDiv.children[0].children[0].getAttribute('data-lp-engagement-id');

    if (!engId) {
      return false;
    }

    success = initEngagement(divId, engId);

    return success;
  }

  function verifyLivePersonIsReady() {
    if (window.lpTag?.taglets?.rendererStub) {
      return true;
    }

    return false;
  }

  function verifyServiceIsReady(divId) {
    var isLivePersonReady = verifyLivePersonIsReady();
    var isEngagementReady = false;

    if (!isLivePersonReady) {
      return false;
    }
    isEngagementReady = verifyEngagementIsReady(divId);
    if (!isEngagementReady) {
      return false;
    }

    return true;
  }

  function performEngagementClick(engId) {
    var success = false;

    if (engId) {
      success = window.lpTag.taglets.rendererStub.click(engId);
    }

    return success;
  }

  function handleIntervalFail(chatOrcData, lpErrorMessageEvent, intentLoop) {
    chatOrcData.intentLoopTimeoutCounter--;
    if (chatOrcData.intentLoopTimeoutCounter === 0) {
      chatOrcData.isLoopActive = false;
      clearInterval(intentLoop);
      document.dispatchEvent(lpErrorMessageEvent);
    }
  }

  function handleServiceError() {
    console.warn(
      `lpOrchestrator: The attempt to initiate a LivePerson chat session was unsuccessful.`
    );
  }

  async function startIntentLoop(divId) {
    var chatOrcData = {};
    var eventName;
    var lpIntentLoopCompleteEvent;
    var errorEventName = 'livechat_ui_error';
    var lpErrorMessageEvent = new Event(errorEventName, { bubbles: true });

    try {
      switch (divId) {
        case window.LiveChat.lpBeautyChatOrcData.divId:
          chatOrcData = window.LiveChat.lpBeautyChatOrcData;
          break;
        case window.LiveChat.lpSupportChatOrcData.divId:
          chatOrcData = window.LiveChat.lpSupportChatOrcData;
          break;
        case window.LiveChat.lpChatOrcData.divId:
          chatOrcData = window.LiveChat.lpChatOrcData;
          break;
        default:
          throw new Error(
            `lpOrchestrator: The div id used in the function startIntentLoop() is not recognized: ${divId}. The chat module for this site is misconfigured.`
          );
      }

      if (Object.keys(chatOrcData).length === 0) {
        throw new Error(
          'lpOrchestrator: The lp__ChatOrcData object is empty. Something is wrong.'
        );
      }

      if (!document.getElementById(divId)) {
        throw new Error(
          `lpOrchestrator.initEngagement(): The LivePerson HTMLEngagement div was not found: ${divId} - The LiveChat system for this site is misconfigured.`
        );
      }

      chatOrcData.isLoopActive = true;
      chatOrcData.isUserAwaitingChat = true;

      eventName = chatOrcData.intentLoopFinishedEventName;
      errorEventName = chatOrcData.errorMessageEventName;

      lpIntentLoopCompleteEvent = new Event(eventName, { bubbles: true });
      lpErrorMessageEvent = new Event(errorEventName, { bubbles: true });

      chatOrcData.intentLoop = setInterval(function () {
        let success = false;
        const isReady = verifyServiceIsReady(divId);

        if (!isReady) {
          handleIntervalFail(chatOrcData, lpErrorMessageEvent, chatOrcData.intentLoop);
          return;
        }
        success = performEngagementClick(chatOrcData.engId);
        if (success) {
          chatOrcData.isLoopActive = false;
          clearInterval(chatOrcData.intentLoop);
          document.dispatchEvent(lpIntentLoopCompleteEvent);
        } else {
          handleIntervalFail(chatOrcData, lpErrorMessageEvent, chatOrcData.intentLoop);
        }
      }, 1000);

      // Listen for the loop completion event
      document.addEventListener(eventName, function () {
        clearInterval(chatOrcData.intentLoop);
        chatOrcData.intentLoop = null;
        chatOrcData.intentLoopTimeoutCounter = chatOrcData.intentLoopTimeoutDefault;
        chatOrcData.isUserAwaitingChat = false;
      });

      // Listen for the error event
      document.addEventListener(errorEventName, function () {
        clearInterval(chatOrcData.intentLoop);
        chatOrcData.intentLoop = null;
        chatOrcData.intentLoopTimeoutCounter = chatOrcData.intentLoopTimeoutDefault;
        chatOrcData.isUserAwaitingChat = false;

        handleServiceError();
      });

    } catch (e) {
      document.dispatchEvent(lpErrorMessageEvent);
      console.error(e);
    }
  }

  async function endIntentLoop(divId) {
    try {
      let chatOrcData = {};

      // Determine the correct chatOrcData object based on divId
      switch (divId) {
        case window.LiveChat.lpBeautyChatOrcData.divId:
          chatOrcData = window.LiveChat.lpBeautyChatOrcData;
          break;
        case window.LiveChat.lpSupportChatOrcData.divId:
          chatOrcData = window.LiveChat.lpSupportChatOrcData;
          break;
        case window.LiveChat.lpChatOrcData.divId:
          chatOrcData = window.LiveChat.lpChatOrcData;
          break;
        default:
          throw new Error(
            `lpOrchestrator: The div id used in the function endIntentLoop() is not recognized: ${divId}. The chat module for this site is misconfigured.`
          );
      }

      // Ensure chatOrcData exists and is valid
      if (Object.keys(chatOrcData).length === 0) {
        throw new Error(
          'lpOrchestrator: The lp__ChatOrcData object is empty. Something is wrong.'
        );
      }

      if (!chatOrcData.isLoopActive) return;

      // Clear the active intent loop, if any
      const eventName = chatOrcData.intentLoopFinishedEventName;
      const lpIntentLoopCompleteEvent = new Event(eventName, { bubbles: true });
      document.addEventListener(eventName, function () {
        clearInterval(chatOrcData.intentLoop);
        chatOrcData.intentLoop = null;
        chatOrcData.intentLoopTimeoutCounter = chatOrcData.intentLoopTimeoutDefault;
        chatOrcData.isLoopActive = false;
        chatOrcData.isUserAwaitingChat = false;
      });
      document.dispatchEvent(lpIntentLoopCompleteEvent);
    } catch (e) {
      console.error(`Error in endIntentLoop for divId: ${divId}`, e);
    }
  }

  // Fires when the user clicks the Beauty Chat button in the drawer
  window.LiveChat.onBeautyChatButtonClick = function () {
    if (window.LiveChat.lpBeautyChatOrcData.isLoopActive) {
      return;
    }
    startIntentLoop(window.LiveChat.lpBeautyChatOrcData.divId);
  };

  // Fires when the user clicks the Support Chat button in the drawer
  window.LiveChat.onSupportChatButtonClick = function () {
    if (window.LiveChat.lpSupportChatOrcData.isLoopActive) {
      return;
    }
    startIntentLoop(window.LiveChat.lpSupportChatOrcData.divId);
  };

  // Fires when the user clicks the Chat button
  window.LiveChat.onChatButtonClick = function (divId) {
    window.LiveChat.lpChatOrcData.divId = divId;
    if (window.LiveChat.lpChatOrcData.isLoopActive) {
      return;
    }
    startIntentLoop(window.LiveChat.lpChatOrcData.divId);
  };

  // Fires when the user clicks the close chat drawer button
  window.LiveChat.onCloseButtonClick = function (divId) {
    if (window.LiveChat.lpBeautyChatOrcData.isLoopActive) {
      endIntentLoop(window.LiveChat.lpBeautyChatOrcData.divId);
    } else if (window.LiveChat.lpSupportChatOrcData.isLoopActive) {
      endIntentLoop(window.LiveChat.lpSupportChatOrcData.divId);
    } else if (window.LiveChat.lpChatOrcData.isLoopActive) {
      window.LiveChat.lpChatOrcData.divId = divId;
      endIntentLoop(window.LiveChat.lpChatOrcData.divId);
    } else {
      return;
    }
  };
})();
